/** Wraps setTimeout in a promise. e.g. await wait(200) asynchronously pauses a function for 200 milliseconds. */
const wait = <T>(milliseconds: number): Promise<T> =>
  new Promise(resolve => {
    setTimeout(resolve, milliseconds)
  })

export default wait
